<div class="status-block">
  <div class="first-text {{ firstTextColor }}" *ngIf="!!firstText" [ngClass]="{ 'with-triangle': !!hintText || !!secondText }">
    {{ firstText | translate }}
  </div>
  <div class="first-text {{ firstTextColor }} empty" *ngIf="!!firstText" [ngClass]="{ triangle: !!hintText || !!secondText }"></div>
  <div *ngIf="secondText" class="second-text {{ secondTextColor }}" [ngClass]="{ 'without-first-text': !firstText }">
    {{ secondText | translate }}
  </div>
  <ng-container *ngIf="hintText">
    <ng-container *ngIf="pointColor">
      <div class="point {{ pointColor }}"></div>
    </ng-container>
    <div class="hint-text {{ hintTextColor }}" [ngClass]="{ 'without-first-text': !secondText }">{{ hintText | translate }}</div>
  </ng-container>
</div>
